import portalAPI from '../api/api';
import { ADD_REIMBURSEMENT_URL } from '../api/URLs';
import { updateUser } from '../stores/authenticated-user.store';
import { formatStateCode } from './states-list';

/**
 * Ensures "check-by-mail" reimbursement method exists for the user.
 * Adds it if not present.
 * 
 * @param {Function} dispatch - Redux dispatch function.
 * @param {Object} user - Current user object.
 * @returns {Promise<boolean>} - Returns true if updated, false otherwise.
 */
export const UpdateDefaultMethod = async (dispatch, user) => {
    try {

        const checkByMail = user.reimbursementMethods?.find(
            (item) => item.method === 'check-by-mail'
        );

        if (checkByMail) {
            return false;
        }

        const address = user.address;
        if (!address || !address.line1 || !address.city || !address.state || !address.zip) {
            console.warn("UpdateDefaultMethod: Incomplete address. Skipping update.");
            return false;
        }

        const body = {
            method: "check-by-mail",
            option: 'yes',
            checkByMail: {
                recipientName: user.fullName || '',
                address1: address.line1,
                address2: address.line2 || '',
                city: address.city,
                state: formatStateCode(address.state),
                zip: address.zip,
            },
        };

        const response = await portalAPI.put(ADD_REIMBURSEMENT_URL, body);

        if (response?.data?.status === 200 && response?.data?.data?.reimbursementMethods) {
            dispatch(updateUser({
                key: 'reimbursementMethods',
                value: response.data.data.reimbursementMethods,
            }));
            return true;
        } else {
            console.error("Failed to update reimbursement method:", response?.data?.message || 'Unknown error');
            return false;
        }
    } catch (error) {
        console.error("UpdateDefaultMethod: Exception occurred", error);
        return false;
    }
};